import posthog from 'posthog-js'

/**
 * Weekly launch-test diagnostic events (U9). Client-side only (posthog-js); these feed the
 * conversion funnel and reading-stickiness views and are segmentable by the `weekly_test_group`
 * person property set in App.tsx. They are diagnostics — no source-of-truth metric depends on them.
 */
export type WeeklyEvent =
  | 'weekly_offer_plan_viewed'
  | 'weekly_checkout_started'
  | 'weekly_purchase_succeeded'
  | 'weekly_story_opened'
  | 'weekly_story_completed'

export const captureWeeklyEvent = (event: WeeklyEvent, properties: Record<string, any> = {}): void => {
  try {
    posthog.capture(event, properties)
  } catch {
    // Diagnostics must never break the app.
  }
}
